import React from "react";
import ReceiptDetail from "./ReceiptDetail";

const ReceiptDetailPage: React.FC = () => {
  return <ReceiptDetail />;
};

export default ReceiptDetailPage;
